
import Slider from "react-slick";
export default function ListSlider({ training }) {
    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/> </svg>
            </div>
        );
    }
    
    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/> </svg>
            </div>
        );
    }
    const settings = {
        dots: false,
        infinite: false,
        arrows: true,
        centerPadding: "60px",
        speed: 500,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              }
            }
        ]
    };  
	return (
		<>
        <div class="kitbug-post-slider-area design-one arrow-design-two">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">

                        <div class="kitbug-items-slider-area">
                            {training == null ? 'loading..' : 
                                <Slider  {...settings}>
                                    {
                                        training.map(
                                            ({title, meta_box, link}) => {
                                                const {templateburg_p_me_eriodo, templateburg_author, templateburg_author_image} = meta_box
                                                return(
                                                    <div class="kitbug-item-slide-start ">
                                                        <div class="kitbug-item-slide design-three white-bg">
                                                            {title.rendered &&
                                                                <a class="title-info" href={link}><h4>{title.rendered}</h4></a>
                                                            }

                                                            
                                                            {templateburg_p_me_eriodo &&
                                                                <div class="auth-info-p">
                                                                    <h5 class="name-title">Periodo:</h5>
                                                                    <h6 class="name-content">{templateburg_p_me_eriodo}</h6>
                                                                </div>
                                                            }
                                                            <div class="auth-info-area">
                                                                {templateburg_author_image != null && templateburg_author_image.length > 0 && 
                                                                    <div class="auth-img">
                                                                        <img
                                                                            src={templateburg_author_image[0].url}
                                                                            alt={templateburg_author ? templateburg_author : 'author'}
                                                                        />
                                                                    </div>
                                                                }
                                                                {templateburg_author &&
                                                                    <div class="auth-info">
                                                                        <h5 class="name-title">Coordinatore:</h5>
                                                                        <h6 class="name-content">{templateburg_author}</h6>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <a class="kitbug-btn kitbug-btn-style-three" href={link}>
                                                                SCOPRI IL CORSO
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.001" viewBox="0 0 14 14.001">
                                                                    <path id="oyi" data-name="Subtraction 1" d="M19217,9774a7,7,0,1,1,7-7A7.008,7.008,0,0,1,19217,9774Zm-1-10a.429.429,0,0,0-.3.733l2.268,2.268-2.268,2.268a.441.441,0,0,0-.125.309.415.415,0,0,0,.125.3.42.42,0,0,0,.3.126.434.434,0,0,0,.3-.126l2.576-2.571a.427.427,0,0,0,.01-.589l-2.582-2.591A.444.444,0,0,0,19216,9764Z" transform="translate(-19210 -9759.999)" fill="#fff"/>
                                                                </svg>
                                                            </a>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        )
                                    }
                                </Slider>
                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>
		</>
	);
}
